import SectionHeader from '../Faq/SectionHeader'
import ReachOut from './ReachOut'
import SendMessage from './SendMessage'

const Contact = () => {
  return (
    <>
      <SectionHeader
        title="Want to start a conversation?"
        subtitle="Connect With Us."
        description="At Safelto, we're passionate about building meaningful relationships with our customers, partners, and community. We believe that connection is the key to unlocking new ideas, fostering growth, and driving success"
        className="max-w-[90%] lg:max-w-[73.125rem] mx-auto px-8 lg:px-40 text-center mt-5 lg:mt-20 gap-1 lg:gap-3"
        subTitleStyle="text-[28px] md:text-5xl leading-tight md:leading-[72px] md:whitespace-normal"
        descriptionStyle="text-sm md:text-lg md:text-center"
     
      />
      <ReachOut />
      <SendMessage />
    </>
  )
}

export default Contact
